export default __webpack_public_path__ + "static/media/foliage_mini.5a2e95d9.jpg";